import { dictionary } from "../dictionary";

export const getSupportedLanguages = () => {
	Object.keys(dictionary).map(k => {
		return {
			key:k,
			label:k.toUpperCase()
		}
	});
}
